import React from 'react';

export default () => (
  <section className="b-bnr bg-dark">
    <div className="container">
      <div className="row">
        <div className="col-xl-9">
          <div className="b-bnr__main">
            <h2 className="b-bnr__title">
              <span className="text-primary">VL Cars</span>
              {startup.content.NumberSectionTitle}
            </h2>
            <div className="b-bnr__info">
              {startup.content.NumberSectionSubtitle}
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="b-bnr__second">
            <div className="b-bnr-contacts">
              <div className="b-bnr-contacts__info">
                {startup.content.CallUsForBookingCar}
              </div>
              <a className="b-bnr-contacts__phone" href={startup.phoneLink}>
                <i className="ic icon-call-end text-primary" />
                {startup.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
